
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>RTI</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
    <ul class="breadcrumb">
        <li><a href="#">About Us</a></li>
        <li><i class="fa fa-angle-double-right"></i></li>
        <li>RTI</li>
    </ul>

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="inner-title"  >
                    <h3>RTI-ACT Judgement of High Court</h3>							
                   
                </div>
                <div class="text-justify" >
                    <iframe src="https://drive.google.com/file/d/10Cla_TuOCVkGJLzanqw8cKYC0JUVEUvZ/preview" width="100%" height="650px"></iframe>
                </div>                    
            </div>
        </div>
    </div>
</section>

